import { render, staticRenderFns } from "./MemoCard.vue?vue&type=template&id=5ab5387c&scoped=true"
import script from "./MemoCard.vue?vue&type=script&lang=js"
export * from "./MemoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab5387c",
  null
  
)

export default component.exports